import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function CountdownSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="w-full bg-[#0a0a0a] px-5 pb-16 sm:px-8" data-id="element-38" data-mp="2zwk4o5tugrve">
      <div className="mx-auto w-full max-w-3xl overflow-hidden rounded-2xl border border-[#6d28d9]/60 bg-[#141416]" data-id="element-39" data-mp="3dv091q48i6ad">
        <div className="h-1 w-full bg-gradient-to-r from-[#6d28d9] via-[#c2410c] to-[#facc15]" data-id="element-40" data-mp="39rbyqzo7wwlf" />
        <div className="px-6 py-8 text-center sm:px-10" data-id="element-41" data-mp="3nqk1u3ni4ouw">
          <p className="text-[11px] font-extrabold uppercase tracking-widest text-[#7c3aed]" data-id="element-42" data-mp="3ittk7bw1tl7d">
            ⏰ Limited-time offer
          </p>
          <h2 className="mt-3 text-2xl font-extrabold text-white sm:text-3xl" data-id="element-43" data-mp="1c0o896cpdph">
            Launch Price Ends In:
          </h2>

          <div className="mt-6 flex items-start justify-center gap-2 sm:gap-4" data-id="element-44" data-mp="adi0fggn0v8w">
            {[{
            value: hours,
            label: 'HRS'
          }, {
            value: minutes,
            label: 'MIN'
          }, {
            value: seconds,
            label: 'SEC'
          }].map((unit, index) => <React.Fragment key={unit.label} data-id="element-45" data-mp="1dnujy6ruuvdg" data-mpi={index}>
                {index > 0 && <span aria-hidden="true" className="text-4xl font-extrabold text-[#6d28d9] sm:text-6xl" data-id="element-46" data-mp="1ilmj9lutxjro">
                    :
                  </span>}
                <div data-id="element-47" data-mp="1sgxptgw33koc">
                  <p className="text-4xl font-extrabold tabular-nums text-[#6d28d9] sm:text-6xl" data-id="element-48" data-mp="1wl5itq9krmsd">
                    {unit.value}
                  </p>
                  <p className="mt-1 text-[11px] font-bold uppercase tracking-widest text-neutral-400" data-id="element-49" data-mp="21i5mxvmv6fgu">
                    {unit.label}
                  </p>
                </div>
              </React.Fragment>)}
          </div>

          <p className="mt-8 text-base font-bold text-white" data-id="element-50" data-mp="2g94qgs8uedtk">
            After that, the price goes up and bonuses are removed.
          </p>

          <div className="mt-8" data-id="element-51" data-mp="2kb9ftes9coae">
            <div className="h-2 w-full overflow-hidden rounded-full bg-[#2a2a2e]" data-id="element-52" data-mp="2k83so536vwhb">
              <div className="h-full rounded-full bg-gradient-to-r from-[#6d28d9] via-[#c2410c] to-[#facc15]" style={{
              width: '72%'
            }} data-id="element-53" data-mp="l5ye43zk5f8k" />
            </div>
            <div className="mt-3 flex items-center justify-between text-[11px] font-bold uppercase tracking-wider" data-id="element-54" data-mp="tzbflubotp69">
              <span className="text-[#7c3aed]" data-id="element-55" data-mp="p5gucmgfp252">🔴 Limited spots</span>
              <span className="text-neutral-300" data-id="element-56" data-mp="13umvifyu12fl">72% claimed</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}